import { render, staticRenderFns } from "./UbicateTree.vue?vue&type=template&id=4da17386&"
import script from "./UbicateTree.vue?vue&type=script&lang=js&"
export * from "./UbicateTree.vue?vue&type=script&lang=js&"
import style0 from "./UbicateTree.vue?vue&type=style&index=0&id=4da17386&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports